import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { template1PreviewData } from '../../lib/TemplatesData';
import arrowUpIcon from '../../assets/arrowUpIcon.svg'
import { ensureUrlProtocol } from '../../lib/util';


const Template1 = () => {
    const iconStyle = { fontSize: '15px', marginTop: '3px', marginRight: '3px' };
    let formData = localStorage.getItem("formData");
    formData = formData !== null ? JSON.parse(formData) : template1PreviewData;
    const { firstName = '', lastName = '', email = '', phone = '', country = '', city = '', links = [], Experience = [], Education = [], Skills = [], Projects = [] } = formData;

    return (
        <div className="px-6 ">
            <div className='flex items-center flex-col w-full'>
                <div className='text-3xl mt-2'>{firstName} {lastName}</div>
                <div>{city}, {country}</div>
                <div className='flex justify-center w-full flex-wrap '>
                    {phone !== '' && <div className='flex items-center mx-1.5'><FaPhoneAlt style={iconStyle} /> <span className='underline underline-offset-4 text-sm' >{phone}</span></div>}
                    {email !== '' && <div className='flex items-center mx-1.5'><FaEnvelope style={iconStyle} /> <a href={`mailto:${email}`} className='underline underline-offset-4 text-sm'>{email}</a></div>}
                    {links.length > 0 && links.map((item, index) => {
                        const { label = '', link = '' } = item;
                        const formattedLink = ensureUrlProtocol(link)
                        const domain = link.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
                        return label!=='' && <div key={index} className='flex items-center mx-1'>
                            {link!=='' && <img
                                src={`https://img.logo.dev/${domain}?token=pk_epQ-03M2S36qD6zus6lrXQ`}
                                alt={``}
                                width="20"
                                height="20"
                                style={iconStyle}
                                onError={(e) => {
                                    e.currentTarget.onerror = null; // Prevents infinite loop if fallback also fails
                                    e.currentTarget.src = arrowUpIcon;
                                    e.currentTarget.width= '15'
                                    e.currentTarget.height = '15'
                                }}
                            />}
                            <a href={formattedLink} target='_blank' rel="noreferrer" className='underline underline-offset-4 text-sm'>{label} </a> </div>
                    })}
                </div>
            </div>
            {Experience.length > 0 && <div className='flex w-full mt-3 flex-col'>
                <div className='text-xl font-bold'>EXPERIENCE</div>
                <div className='w-full h-[1.5px] bg-black'></div>

                {Experience.map((item, index) => {
                    const { employer = '', jobTitle = '', city = '', desc = '', startDate = '', endDate = '' } = item;
                    return <div key={index}>
                        <div className='flex justify-between'>
                            <span className='text-base font-semibold'>{employer}</span>
                            <span className='text-sm font-semibold'>{startDate}-{endDate}</span>
                        </div>
                        <div className='flex justify-between'>
                            <span className='italic underline underline-offset-4 font-normal'>{jobTitle}</span>
                            <span className='text-sm font-medium'>{city}</span>
                        </div>
                        <div
                            dangerouslySetInnerHTML={{ __html: desc }}
                            className='exp-list'
                        />
                    </div>
                })}
            </div>}
            {Education.length > 0 && <div className='flex w-full flex-col'>
                <div className='text-xl font-bold'>Education</div>
                <div className='w-full h-[1.5px] bg-black'></div>
                {Education.map((item, index) => {
                    const { degree = '', college = '', city = '', desc = '', startDate = '', endDate = '' } = item;
                    return <div key={index}>
                        <div className='flex justify-between '>
                            <span className='text-base font-semibold'>{college}</span>
                            <span className='text-md font-medium'>{city}</span>
                        </div>
                        <div className='flex justify-between'>
                            <span className='font-normal'>{degree}</span>
                            <span className='text-sm font-medium'>{startDate}-{endDate}</span>
                        </div>
                        {desc !== '' && <div
                            dangerouslySetInnerHTML={{ __html: desc }}
                            className='exp-list'
                        />}
                    </div>
                })}
            </div>}
            {Projects.length > 0 && <div className='flex w-full mt-3 flex-col'>
                <div className='text-xl font-bold'>Projects</div>
                <div className='w-full h-[1.5px] bg-black'></div>
                {Projects.map((item, index) => {
                    const { title = '', techStack = '', link = '', desc = '', sourceCode = '' } = item;
                    const formattedLink = ensureUrlProtocol(link)
                    const formattedSourceCodeLink = ensureUrlProtocol(sourceCode)
                    return <div key={index}>
                        <div className='flex justify-between'>
                            <div className='flex items-center'>
                                <span className='text-base font-semibold underline underline-offset-2'>{title} </span>
                                {link !== '' && <a className='ml-1' href={formattedLink} target='_blank' rel="noreferrer"> <FaArrowUpRightFromSquare style={iconStyle} /> </a>}
                                <span className='mx-1'>|</span>
                                <span className='text-sm font-normal underline underline-offset-4'>Tech Stack: {techStack}</span>
                                {sourceCode !== '' && <span className='mx-1'>|</span>}
                                {sourceCode !== '' && <a href={formattedSourceCodeLink} target='_blank' rel="noreferrer" className='cursor-pointer flex items-center text-sm font-medium underline underline-offset-4'> <span>source code</span>  <FaArrowUpRightFromSquare className='ml-1' style={{ fontSize: '12px', marginTop: '2px' }} /></a>}

                            </div>
                        </div>
                        {desc !== '' && <div
                            dangerouslySetInnerHTML={{ __html: desc }}
                            className='project-list'
                        />}
                    </div>
                })}
            </div>}
            {Skills.length > 0 && <div className='flex w-full mt-1 flex-col'>
                <div className='text-xl font-bold'>Skills</div>
                <div className='w-full h-[1.5px] bg-black'></div>
                <div className='skill-list'>
                    <ul className="grid-list">
                        {Skills.map((item, index) => {
                            const { skill = '' } = item;
                            return <li key={index}>{skill}</li>;
                        })}
                    </ul>
                </div>
            </div>}
        </div>
    )
}

export default Template1